import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedServiceId } from '../../modules/services/store/actions/index';
import { useHistory } from 'react-router';
import axios from 'axios';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import Badge from '@material-ui/core/Badge';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell } from '@fortawesome/free-solid-svg-icons';
import { CommonConfig } from '../../config/common-config';
import token from '../../config/token';
import './styles.css';
import moment from 'moment';

const useStyles = makeStyles({
    list: {
        width: 430,
        ['@media (min-width:280px)']: {
            width: '100%',
        },
    },
    fullList: {
        width: 'auto',
    },
});

export default function Notification() {
    const tokens = token();
    const classes = useStyles();
    const [state, setState] = React.useState({
        right: false,
    });
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    const [notificationsList, setNotificationsList] = useState([]);
    const menuContents = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails);
    const dispatch = useDispatch({});
    const history = useHistory();

    const toggleDrawer = (anchor, open) => (event) => {
        if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        setState({ ...state, [anchor]: open });
    };

    const getNotifications = () => {
        axios
            .get(`${CommonConfig.dev.baseUrl6050}/get-latest-notification`, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                setNotificationsList(response.data);
            })
            .catch(() => {
            });
    };

    const readNotifications = (id) => {
        axios
            .post(`${CommonConfig.dev.baseUrl6050}/read-notification/${id}`, '', {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                setNotificationsList(
                    notificationsList.map((x) => {
                        if (x.snId !== id) return x;
                        return { ...x, unread: false };
                    })
                );
            })
            .catch(() => {
            });
    };

    useEffect(() => {
        if (typeof bearerToken !== undefined) {
            getNotifications();
            const interval = setInterval(() => {
                getNotifications();
            }, 120000);
            return () => clearInterval(interval);
        }
    }, [tokens]);

    const readNotification = (id, row) => {
        dispatch(setSelectedServiceId(row.serviceId));
        readNotifications(id);
        const branchName = menuContents.result.data && menuContents.result.data.features[0].branchName;
        if (row.stageId === 2 && branchName === 'Ultimate Client') {
            history.push('/menu/checkListUltimate');
        }
    };
    const filteredArray = notificationsList && notificationsList.filter((item) => item.unread);
    const notificationsCount = filteredArray.length;

    const list = (anchor) => (
        <div
            className={clsx(classes.list, {
                [classes.fullList]: anchor === 'top' || anchor === 'bottom',
            })}
            role="presentation"
        >
            <div className="notification">
                <h2>Notifications ({notificationsCount}) </h2>
                <List>
                    {notificationsList &&
                        notificationsList
                            .sort((a, b) => b.snId - a.snId)
                            .map((row, index) => (
                                <ListItem
                                    button
                                    key={row.snId}
                                    className={row.unread === true ? '' : 'notiread'}
                                    onClick={() => readNotification(row.snId, row)}
                                >
                                    <ListItemIcon>
                                        {
                                            index % 2 === 0 ? (
                                                <span className="dateAlternate1">{row.createdDate.split('-', 3)[2].split(' ', 1)}</span>
                                            ) : (
                                                    <span className="dateAlternate2">{row.createdDate.split('-', 3)[2].split(' ', 1)}</span>
                                                )
                                        }
                                    </ListItemIcon>
                                    <ListItemText>
                                        <div className="notiContent">{row.notificationMessage}</div>
                                        <div className="notiContent">{moment(row.createdDate).format('DD-MM-YYYY HH:mm:ss')}</div>
                                    </ListItemText>
                                </ListItem>
                            ))}
                </List>
                <Divider />
            </div>
        </div>
    );

    return (
        <div>
            {['right'].map((anchor) => (
                <React.Fragment key={anchor}>
                    <Badge
                        badgeContent={notificationsCount}
                        color="secondary"
                        onClick={toggleDrawer(anchor, true)}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                    >
                        <FontAwesomeIcon icon={faBell} />
                    </Badge>

                    <SwipeableDrawer
                        anchor={anchor}
                        open={state[anchor]}
                        onClose={toggleDrawer(anchor, false)}
                        onOpen={toggleDrawer(anchor, true)}
                        swipeAreaWidth={0}
                    >
                        {list(anchor)}
                    </SwipeableDrawer>
                </React.Fragment>
            ))}
        </div>
    );
}
